<template>
  <div>
    <BillSelectTableDialog
      :title="title"
      ref="billDialogRef"
      :searchColumns="searchColumns"
      :columnList="columnList"
      :defaultVisible="billDialogVisible"
      :API="getApi"
      :extraData="getExtraData"
      :getDataKey="'records'"
      :confirmUnchecked="false"
      :isMultiple="true"
      :tempBillList="tempBillList"
      width="800px"
      @close="close"
      @confirm="confirmBill"
      @resetBtnClick="resetBtnClick"
    />
    <SelectTableDialog
      :title="title"
      ref="certDialogRef"
      :searchColumns="searchColumns"
      :columnList="columnList"
      :defaultVisible="certDialogVisible"
      :API="getApi"
      :extraData="getExtraData"
      :getDataKey="'records'"
      :confirmUnchecked="false"
      :isMultiple="true"
      width="800px"
      @close="close"
      @confirm="confirmCert"
      @resetBtnClick="resetBtnClick"
    />
  </div>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import BillSelectTableDialog from './selectTable.vue';
  import BILL_API from '@/api/capitalCenter/bill';
  import LC_API from '@/api/capitalCenter/letterOfCredit';
  export default {
    props: ['feeInfo'],
    components: {
      SelectTableDialog,
      BillSelectTableDialog,
    },
    data() {
      return {
        title: '新增票据',
        billDialogVisible: false,
        certDialogVisible: false,
        infoList: [],
        tempBillList: [], //填写使用金额后，再次打开会显示已经填写过的值
      };
    },
    computed: {
      getApi() {
        if (this.title == '新增票据') {
          return BILL_API.QUERY_FUNDBILL_PAGE;
        }
        return LC_API.QUERY_CREDITLETTER_PAGE;
      },
      getExtraData() {
        if (this.title == '新增票据') {
          return this.feeInfo.paymentMethod == '10'
            ? {
                billCompanyCode: this.feeInfo?.requestCompanyCode,
                billStatusList: ['01', '05', '06', '08'],
              }
            : {
                billType: '2',
                billCompanyCode: this.feeInfo?.requestCompanyCode,
                // billStatus: '03',
              };
        }
        return {
          sourceType: '1',
          statusFlags: ['005', '006', '007', '008'],
        };
      },
      searchColumns() {
        if (this.title == '新增票据') {
          return [
            {
              name: this.$t('billList.column.billCode'),
              prop: 'billCode',
              type: 'input',
            },
            {
              //金额开始结束
              type: 'input',
              prop: 'billAmountMin',
              precision: 2, //精度，就是保留几位小数,默认两位
              max: 99999999999999.99,
              name: '票据金额从',
            },
            {
              //金额开始结束
              type: 'input',
              prop: 'billAmountMax',
              precision: 2, //精度，就是保留几位小数,默认两位
              max: 99999999999999.99,
              name: '票据金额到',
            },
            {
              // 开票日期从
              name: '开票日期从',
              prop: 'expiringDateBegin',
              type: 'startDaterangePicker',
            },
            {
              // 到期日到
              name: '到期日到',
              prop: 'expiringDateEnd',
              type: 'endDaterangePicker',
            },
          ];
        } else {
          return [
            {
              prop: 'clCode',
              name: '信用证号',
              label: '信用证号',
              type: 'input',
            },
          ];
        }
      },
      columnList() {
        if (this.title == '新增票据' && this.userInfo.businessGroup == '物贸') {
          return [
            {
              prop: 'billSerialNumber',
              label: this.$t('billList.column.billSerialNumber'),
              width: 150,
            },
            {
              prop: 'billCode',
              label: this.$t('billList.column.billCode'),
              width: 150,
            },
            {
              prop: 'expiringDate',
              label: '到期日',
              width: 150,
            },
            {
              prop: 'billAmount',
              label: '票据金额',
              width: 120,
            },
            {
              // 可用金额
              prop: 'availableAmount',
              label: '可用金额',
              width: 120,
            },
            {
              // 使用金额
              prop: 'useAmount',
              label: '使用金额',
              width: 120,
              editRender: {
                name: 'input',
                attrs: { type: 'number' },
              },
            },
          ];
        } else if (this.title == '新增票据') {
          return [
            {
              prop: 'billSerialNumber',
              label: this.$t('billList.column.billSerialNumber'),
              width: 150,
            },
            {
              prop: 'billCode',
              label: this.$t('billList.column.billCode'),
              width: 150,
            },
            {
              prop: 'expiringDate',
              label: '到期日',
              width: 150,
            },
            {
              prop: 'billAmount',
              label: '票据金额',
              width: 120,
            },
          ];
        } else {
          return [
            {
              prop: 'clCode',
              label: '信用证号',
              width: 250,
            },
          ];
        }
      },
    },
    methods: {
      open(title = '新增票据', data) {
        this.title = title;
        if (this.title == '新增票据') {
          this.billDialogVisible = true;
          this.tempBillList = data;
        } else {
          this.certDialogVisible = true;
        }
        this.$nextTick(() => {
          this.setInit();
        });
      },
      setInit() {
        let table;
        if (this.title == '新增票据') {
          table = this.$refs.billDialogRef;
          // this.$refs.selectTableDialog.query = {
          //   billCode: null,
          //   billAmountMin: null,
          //   billAmountMax: null,
          //   expiringDateBegin: null,
          //   expiringDateEnd: null,
          // };
        } else {
          table = this.$refs.certDialogRef;
          // this.$refs.selectTableDialog.query = { clCode: null };
        }
        table.initQuery();
        this.infoList = [];
      },
      close() {
        this.billDialogVisible = false;
        this.certDialogVisible = false;
        // ================= 清空选中 =================
        this.$refs.billDialogRef?.$refs.siruiTable?.clearCheckboxReserve();
        this.$refs.certDialogRef?.$refs.siruiTable?.clearSelectRecord();
        // ============================================
      },
      async confirmBill(val) {
        if (!val[0]) {
          return this.$message({ showClose: true, message: '请选择一条记录', type: 'error' });
        }
        if (this.userInfo.businessGroup == '物贸') {
          let isJudge = false; //判断使用金额是否大于可用金额
          let isAvailable = false; //可用金额是否大于0
          let isUse = false; //判断是否输入使用金额
          await val.map((item) => {
            console.log(item.useAmount, Boolean(item.useAmount));
            if (item.useAmount > item.availableAmount) {
              isJudge = true;
            } else if (item.availableAmount <= 0) {
              isAvailable = true;
            } else if (!item.useAmount || item.useAmount == 0) {
              isUse = true;
            }
          });
          if (isAvailable) {
            return this.$message({
              showClose: true,
              message: '可用金额为0',
              type: 'error',
            });
          }
          if (isUse) {
            return this.$message({
              showClose: true,
              message: '使用金额不能为空',
              type: 'error',
            });
          }
          if (isJudge) {
            return this.$message({
              showClose: true,
              message: '使用金额不能大于可用金额',
              type: 'error',
            });
          }
        }
        this.$emit('updateBill', val);
        this.close();
      },
      async confirmCert(val) {
        console.log(val);
        if (!val[0]) {
          return this.$message({ showClose: true, message: '请选择一条记录', type: 'error' });
        }
        this.$emit('updateCert', val);
        this.close();
      },
      resetBtnClick() {
        this.setInit();
      },
    },
  };
</script>
